"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = getOffsetParent;

var _ownerDocument = _interopRequireDefault(require("./ownerDocument"));

var _nodeName = _interopRequireDefault(require("./nodeName"));

var _getStyle = _interopRequireDefault(require("./getStyle"));

/**
 * Get the offset parent of a DOM element
 * @param node The DOM element
 * @returns The offset parent of the DOM element
 */
function getOffsetParent(node) {
  var doc = (0, _ownerDocument["default"])(node);
  var offsetParent = node === null || node === void 0 ? void 0 : node.offsetParent;

  while (offsetParent && (0, _nodeName["default"])(node) !== 'html' && (0, _getStyle["default"])(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports.default;